export default {
  computed: {
    /**
     * 总流程长度
     */
    totalFlow() {
      // 如果当前是委托人
      if (this.$store.getters.personRnr.isConsigner) {
        // 新车是7步，二手车是8步
        return this.$store.getters.personRnr.customerType === 0 ? 8 : 8
      }
      // 新车是5步，二手车是6步
      return this.$store.getters.personRnr.customerType === 0 ? 5 : 6
    },

    /**
     * 文件所处的流程
     */
    currentFlow() {
      return this.$route.query.step
    }
  },

  methods: {
    /**
     * 跳转到下一页
     * @param pageName 需要跳转的页名
     */
    routerToNextPage(pageName, query) {
      // 取出当前步骤
      const { step } = this.$route.query
      // 跳转到支付结果页
      this.$router.push({ name: pageName, query: { step: +step + 1, ...(query || {}) }})
    }
  }
}



// WEBPACK FOOTER //
// ./src/minxin/flow.js